// reads and writes to the browser's localStorage

export type STORAGE_KEYS = '_u' | string;

export const addItemToStorage = (key: STORAGE_KEYS, data: string) => {
  return localStorage.setItem(key, data);
};

export const removeItemFromStorage = (key: STORAGE_KEYS) => {
  return localStorage.removeItem(key);
};

export const getItemFromStorage = (key: STORAGE_KEYS) => {
  return localStorage.getItem(key);
};

export const clearStorage = () => {
  return localStorage.clear();
};
